import { createAsyncThunk } from '@reduxjs/toolkit';
import { LoqateRetrieveService } from '../services';
import Config from '../config/config';
import { LoqateRetrieveResponse } from '../services/LoqateRetrieveService/LoqateRetrieveService.types';

export const retrieveAddress = createAsyncThunk<LoqateRetrieveResponse, string>(
  'address/retrieve',
  async (id: string) => {
    const requestData = {
      Key: Config.LOQATE_API_KEY,
      Id: id,
    };
    return await LoqateRetrieveService.loqateRetrieve({
      pathParams: {},
      data: requestData,
    });
  },
);
